<template>
  <div class="message-type">
    <component
      :is="currentComponent"
      v-if="currentComponent"
      :data-item="dataItem"
      :is-self="isSelf"
      :message="message"
    />
    <div v-else class="message-type__unknown">不支持的消息类型</div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { MESSAGE_TYPE_COMPONENT_MAP } from './index.js'

const props = defineProps({
  message: {
    type: Object,
    default: () => ({})
  },
  messageType: {
    type: Number,
    default: undefined
  },
  isSelf: {
    type: Boolean,
    default: false
  },
  dataItem: {
    type: Object,
    default: () => ({
      content: ''
    })
  }
})

const currentComponent = computed(() => MESSAGE_TYPE_COMPONENT_MAP[Number(props.messageType)])
</script>

<style lang="scss" scoped>
.message-type {
  display: flex;
  overflow: hidden;
  border-radius: 8px;
  .message-type__unknown {
    font-size: 12px;
    line-height: 16px;
    color: #969799;
  }
}
</style>
